import { render, staticRenderFns } from "./DetailRecommand.vue?vue&type=template&id=23cb0423&scoped=true&lang=pug&"
import script from "./DetailRecommand.vue?vue&type=script&lang=js&"
export * from "./DetailRecommand.vue?vue&type=script&lang=js&"
import style0 from "./DetailRecommand.vue?vue&type=style&index=0&id=23cb0423&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cb0423",
  null
  
)

export default component.exports